import { Component, OnDestroy, OnInit } from '@angular/core';
import { GstSaleInvCumBosDto } from '../../Model/gst-sale-inv-cum-bos-dto';
import { ProductOrderSummaryServiceService } from '../../services/product-order-summary-service.service';
import { ActivatedRoute, Router } from '@angular/router';
import { LocalStorageService } from '../../services/local-storage.service';
import { Subscription } from 'rxjs';
import { CartService } from '../../services/cart.service';
import { WebOrderMinimumValueSetup } from '../../Model/web-order-minimum-value-setup';
import { CustomerDeliveryAddress } from '../../Model/customer-delivery-address';
import { WebOrderDeliverySetupDto } from '../../Model/web-order-delivery-setup-dto';
import { ViewWebOrderDeliverySetUpDto } from '../../Model/view-web-order-delivery-set-up-dto';
import { ApiFactoryEndPoints } from '../../common/api-factory-end-points';
import { WebOrderDeliveryTimeSlotSetup } from '../../Model/web-order-delivery-time-slot-setup';
import { ProductOrderSummary } from '../../Model/product-order-summary';
import moment from 'moment';
import { DomSanitizer } from '@angular/platform-browser';
import { ViewOfferSetUpDto } from '../../Model/view-offer-set-up-dto';
import { HttpErrorResponse } from '@angular/common/http';
import { ToastService } from '../../services/toast.service';
import { WebOrderDeliveryCheckDto } from '../../Model/web-order-delivery-check-dto';
import { ProductCartDto } from '../../Model/product-cart-dto';
import { CommonExternalModule } from '../../common/common-external-module';
import { MatDialog, MatDialogModule } from '@angular/material/dialog';
import { FormsModule, ReactiveFormsModule, UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { Product } from '../../Model/product';
import { HeaderComponent } from '../../components/header/header.component';
import { DeliveryTimeDialogComponent } from '../../dialog/delivery-time-dialog/delivery-time-dialog.component';
import { GoogleCustomer } from '../../Model/googlecustomer';
import { LoginCustomerDetails } from '../../Model/login-customer-details';
import { ProductService } from '../../services/product.service';
import { GatewayPaymentSetup } from '../../Model/gateway-payment-setup';
import { CCAvenueDataFormat } from '../../Model/ccavenue-data-format';
import { AppConfigService } from '../../services/app-config.service';
import { CustomerDTO } from '../../Model/customer-dto';
import { getWindow } from "ssr-window";

@Component({
  selector: 'app-product-order-summary-component',
  standalone: true,
  imports: [CommonExternalModule, HeaderComponent],
  templateUrl: './product-order-summary-component.component.html',
  styleUrl: './product-order-summary-component.component.css'
})

export class ProductOrderSummaryComponentComponent implements OnInit, OnDestroy {

  mesageForm: UntypedFormGroup;

  deliveryType: string;
  currentUrl: string = '';
  checkout: string;
  allCartTotal = 0;
  totalNetAmt = 0;
  totalSaleAmt = 0;
  totDiscount = 0;
  totTaxValue = 0;
  gstAmt = 0;
  cessAmt = 0;
  totBasePremiumFlavourPrice = 0;
  totPremiumFlavourPrice = 0;
  roundedOffAmount = 0;
  netAmountBeforeRoundedOff = 0;
  deliveryCharge: number = 0;
  distanceDeliveryCharge: number = 0;
  slotDiscDeliveryCharge: number = 0;
  slotPremiumDeliveryCharge: number = 0;
  valueDeliveryCharge: number = 0;
  allowOffer: string;
  grandTotal: number = 0;
  groupProduct: any = [];
  isAllAllowed: boolean = true;
  isShowCheckOut: boolean = false;
  isAgreedTerms: boolean = false;
  isAnimate: boolean = false;

  googleDetails: GoogleCustomer;
  googleCustomer: GoogleCustomer;
  gstSaleInvcumBOS: GstSaleInvCumBosDto = new GstSaleInvCumBosDto();
  minimumOrdeSetup: WebOrderMinimumValueSetup;
  customerDeliveryAddress: CustomerDeliveryAddress;
  webOrderDeliverySetupDto: WebOrderDeliverySetupDto = new WebOrderDeliverySetupDto();
  deliverySetup: ViewWebOrderDeliverySetUpDto[] = [];
  storeLocation: any;
  webOrderDeliveryTimeSlotSetup: WebOrderDeliveryTimeSlotSetup[] = [];
  timeSlot2: string[][] = [];
  timeSlotAvl: string[] = [];
  productOrderSummary: ProductOrderSummary = new ProductOrderSummary();
  todayDate: Date = new Date();

  private webOrderMinimumOrderSubcription: Subscription;
  private webOrderDeliverySubcription: Subscription;
  private webOrderTimeSlotSubcription: Subscription;
  private processSubscription: Subscription;
  private checkServicesAllowedOrNotSubcription: Subscription;

  constructor(
    private localStorage: LocalStorageService,
    private productOrderSummaryService: ProductOrderSummaryServiceService,
    private navRoute: Router,
    private cartService: CartService,
    private route: ActivatedRoute,
    private apiFactory: ApiFactoryEndPoints,
    private sanitizer: DomSanitizer,
    private toastService: ToastService,
    public dialog: MatDialog,
    private formBuilder: UntypedFormBuilder,
    public productService: ProductService,
    private appConfig: AppConfigService,
    private router: Router
  ) {
  }

  ngOnInit() {
    this.currentUrl = window.location.host.replace(':', '');
    this.googleCustomer = JSON.parse(this.localStorage.getItem("google_loggedIn_details"));
    this.parentLocationCode = JSON.parse(this.localStorage.getItem("parent_location_code"));
    this.webUrl = getWindow().location.host;

    // this.webUrl = this.appConfig.setting.cartApiUrl;
    // this.companyCode = JSON.parse(this.localStorage.getItem("company_code"));
    this.deliveryType = JSON.parse(this.localStorage.getItem("delivery_type"));
    // this.storeLocation = JSON.parse(this.localStorage.getItem('pickup_location'));
    this.route.params.subscribe((data) => {
      this.checkout = data["id"];
    });
    this.getWebOrders();
    this.getWebOrderMinimumOrderSetUpList();
    this.onMessageInput();
  }

  ngOnDestroy(): void {

  }

  onMessageInput() {
    this.mesageForm = this.formBuilder.group({
      note: ['']
    })
  }

  getWebOrders() {
    this.gstSaleInvcumBOS = this.productOrderSummaryService.getWebOrder();
  }

  getWebOrderMinimumOrderSetUpList() {
    let productOrderSummary = this.productOrderSummaryService.getOrderSummary();
    if (!productOrderSummary) {
      this.navRoute.navigate(["/cart-items"]);
    } else {
      // if (this.deliveryType == 'delivery') {
      this.webOrderMinimumOrderSubcription = this.cartService.getMinimumOrderList(this.currentUrl).subscribe((data) => {
        this.minimumOrdeSetup = data;
        this.getWebOrderDeliverySetUpList();
      });
      // }
      // else if (this.deliveryType == 'storePickup') {
      //   this.minimumOrdeSetup = new WebOrderMinimumValueSetup();
      //   this.minimumOrdeSetup.orderMinValue = this.storeLocation?.minOrderAmount;
      //   this.getWebOrderDeliverySetUpList();
      // } 
      // else {
      //   this.getWebOrderDeliverySetUpList();
      // }
      // this.webOrderMinimumOrderSubcription = this.productService.getMinimumOrderList(this.currentUrl).subscribe((data) => {
      //   this.minimumOrdeSetup = data;

      //   this.getWebOrderDeliverySetUpList();
      // });
    }
  }

  getWebOrderDeliverySetUpList() {
    let locId: number = JSON.parse(this.localStorage.getItem("location_code"));
    let customerDeliveryAddress: CustomerDeliveryAddress = this.productOrderSummaryService.getCustomerDeliveryAddress();
    this.customerDeliveryAddress = customerDeliveryAddress;
    if (!customerDeliveryAddress && !this.checkout) {
      this.navRoute.navigate(["/cart-items"]);
    }
    if (!this.checkout) {
      let longitude: number = Number(customerDeliveryAddress.longitude);
      let latitude: number = Number(customerDeliveryAddress.latitude);

      this.webOrderDeliverySubcription = this.cartService.getDeliveryList(this.currentUrl, locId, longitude, latitude).subscribe((data) => {
        this.webOrderDeliverySetupDto = data;
        this.deliverySetup = data.viewWebOrderDeliverySetUpDto;
        this.getWebOrderTimeSlotSetUpList();
      });
    } else {
      this.getWebOrderTimeSlotSetUpList();
    }
  }

  getWebOrderTimeSlotSetUpList() {
    const apiUrl = this.deliveryType === 'storePickup' ? this.apiFactory.getTimeSlotDetailsByUrlAndLocId : this.apiFactory.getTimeSlotDetailsByUrl;
    const locId = this.deliveryType === 'storePickup' ? this.storeLocation?.locationCode : null;
    this.webOrderTimeSlotSubcription = this.cartService.getTimeSlotList(apiUrl, this.currentUrl, locId)
      .subscribe((data) => {
        this.webOrderDeliveryTimeSlotSetup = data;
        if (this.deliveryType == 'storePickup') {
          this.webOrderDeliveryTimeSlotSetup.forEach(e => {
            e.deliveryDiscount = null;
            e.deliveryPremium = null;
          })
        }
        data.forEach((element, index) => {
          let arr: string[] = [];
          arr.push(element.fromTime);
          arr.push(element.toTime);

          this.timeSlot2.push(arr);
          this.webOrderDeliveryTimeSlotSetup[index].timeSlot = element.fromTime + "-" + element.toTime;
        });
        this.timeSlot2.forEach((e) => {
          let slotHourFrom = e[0].split(":")[0];
          let slotMinFrom = e[0].split(":")[1];
          let slotHourTo = e[1].split(":")[0];
          let slotMinTo = e[1].split(":")[1];

          let tSlot = slotHourFrom + ":" + slotMinFrom + "-" + slotHourTo + ":" + slotMinTo;
          this.timeSlotAvl.push(tSlot);
        });
        this.getProductOrderSummaryDetails();
      });
  }

  getProductOrderSummaryDetails() {
    this.productOrderSummary = this.productOrderSummaryService.getOrderSummary();
    if (this.productOrderSummary == undefined) {
      this.navRoute.navigate(["/cart-items"]);
    } else {
      var maxDeliveryDate: number = 0;
      var date: any;
      var mtoOrder: boolean = false;

      this.productOrderSummary.cartProducts.forEach((element) => {
        element.defaultDate = element.deliveryDate;
        element.defaultTimeSlotAvl = element.timeSlotAvl;



        if (element.cartProductType == "Make To Order") {
          mtoOrder = true;
          element.taxAmount = element.orderQuantityKgs * element?.taxAmount;
          element.cessAmount = element.orderQuantityKgs * element?.cessAmount;
        } else {
          // Don't pre-set these; let user pick manually
          element.deliveryDate = null;
          element.deliveryTime = null;

          element.taxAmount = element.orderQuantity * element?.taxAmount;
          element.cessAmount = element.orderQuantity * element?.cessAmount;
          if (element.designForProductCode) {
            let product = this.productOrderSummary.cartProducts.find(e => e.product_Code == element.designForProductCode);
            product.designTax = element.tax;
            product.designTaxAmount = element.taxAmount;
            product.designCessAmount = element.cessAmount;
          }
        }
        date = new Date(maxDeliveryDate);
      });
      this.localStorage.setItem("mto_order", JSON.stringify(mtoOrder));
      setTimeout(() => {
        this.sortProductByDate(false);
      }, 1000);
    }
  }

  sortProductByDate(dateChanged: boolean) {
    this.allCartTotal = 0;
    let arrayProducts: any = JSON.parse(JSON.stringify(this.productOrderSummary.cartProducts));

    // this gives an object with dates as keys
    const groups = arrayProducts.reduce(
      (groups, game) => {
        const date = game.deliveryDate;
        const dateTime = date?.concat(game.deliveryTime);
        if (!groups[dateTime]) {
          groups[dateTime] = [];
        }
        groups[dateTime].push(game);
        return groups;
      },
      {}
    );

    // Edit: to add it in the array format instead
    const groupArrays = Object.keys(groups).map((dateTime) => {
      this.totalNetAmt = 0;
      this.totalSaleAmt = 0;
      this.totDiscount = 0;
      this.totTaxValue = 0;
      this.gstAmt = 0;
      this.cessAmt = 0;
      this.totBasePremiumFlavourPrice = 0;
      this.totPremiumFlavourPrice = 0;
      this.roundedOffAmount = 0;
      this.netAmountBeforeRoundedOff = 0;

      groups[dateTime].forEach((element) => {
        // let hour = Number(element.deliveryTime.split(":")[0]);
        if (dateChanged == false) {
          element.selectedDate = element.defaultDate;
        }

        let currTime = moment(new Date()).format("HH:mm");
        let hour = Number(currTime.split(":")[0]);
        let totTime: number = Number(hour * 60) + Number(currTime.split(":")[1].split(" ")[0]);

        element.timeSlotAvl = [];

        if (element.defaultDate < element.selectedDate) {
          this.timeSlot2.forEach((e) => {
            let slotHourFrom = e[0].split(":")[0];
            let slotMinFrom = e[0].split(":")[1];
            let slotHourTo = e[1].split(":")[0];
            let slotMinTo = e[1].split(":")[1];

            let tSlot = slotHourFrom + ":" + slotMinFrom + "-" + slotHourTo + ":" + slotMinTo;
            element.timeSlotAvl.push(tSlot);
          });
        } else {
          this.timeSlot2.forEach((e) => {
            let slotHourFrom = e[0].split(":")[0];
            let slotMinFrom = e[0].split(":")[1];
            let slotHourTo = e[1].split(":")[0];
            let slotMinTo = e[1].split(":")[1];

            let fromSlotTime = Number(slotHourFrom) * 60;
            let toSlotTime = Number(slotHourTo) * 60;

            let currDateMto = element.deliveryDate;
            let currDate = moment(new Date().getDate() + element.minimum_Order_Time).format("YYYY-MM-DD");

            if (currDateMto == currDate) {
              if (totTime >= fromSlotTime && totTime <= toSlotTime) {
              } else if (totTime <= fromSlotTime) {
                let tSlot: any = slotHourFrom + ":" + slotMinFrom + "-" + slotHourTo + ":" + slotMinTo;
                element.timeSlotAvl.push(tSlot);
              }
            } else {
              if (element.cartProductType == "Make To Order") {
                if (element.freeByProductCode) {
                  element.totalAmount = element.subTotal;
                }
                this.todayDate.setDate(new Date().getDate() + element.minimum_Order_Time);
                let todayDate = moment(this.todayDate).format("YYYY-MM-DD");
                if (todayDate == currDateMto) {
                  if (totTime >= fromSlotTime && totTime <= toSlotTime) {
                    // let tSlot: any = slotHourFrom + ":" + slotMinFrom + "-" + slotHourTo + ":" + slotMinTo;
                    // element.timeSlotAvl.push(tSlot);
                    // console.log('Same date ===>', tSlot)
                  } else if (totTime <= fromSlotTime) {
                    let tSlot: any = slotHourFrom + ":" + slotMinFrom + "-" + slotHourTo + ":" + slotMinTo;
                    element.timeSlotAvl.push(tSlot);
                  }
                } else {
                  let tSlot = slotHourFrom + ":" + slotMinFrom + "-" + slotHourTo + ":" + slotMinTo;
                  element.timeSlotAvl.push(tSlot);
                }
              } else {
                let todayDate = moment(currDateMto).format("YYYY-MM-DD");
                if (todayDate == currDateMto) {
                  if (totTime >= fromSlotTime && totTime <= toSlotTime) {
                    // let tSlot: any = slotHourFrom + ":" + slotMinFrom + "-" + slotHourTo + ":" + slotMinTo;
                    // element.timeSlotAvl.push(tSlot);
                  } else if (totTime <= fromSlotTime) {
                    let tSlot: any = slotHourFrom + ":" + slotMinFrom + "-" + slotHourTo + ":" + slotMinTo;
                    element.timeSlotAvl.push(tSlot);
                  }
                } else {
                  let tSlot = slotHourFrom + ":" + slotMinFrom + "-" + slotHourTo + ":" + slotMinTo;
                  element.timeSlotAvl.push(tSlot);
                }
              }
            }
          });
        }

        if (element.orderQuantityKgs == null) {
          this.totalSaleAmt += Number((element.orderQuantity * element.sale_Price).toFixed(2));
          if (element.discountAmt) {
            this.totDiscount += Number((element?.discountAmt * element.orderQuantity).toFixed(2));
          }
          if (element.taxAmount) {
            this.gstAmt += Number((element?.taxAmount).toFixed(2));
          }
          if (element.cessAmount) {
            this.cessAmt += Number((element?.cessAmount).toFixed(2));
          }
          this.totTaxValue = (this.totalSaleAmt + this.totBasePremiumFlavourPrice) - this.totDiscount;
          this.totalNetAmt = this.totTaxValue + this.gstAmt + this.cessAmt;
        } else {
          this.totalSaleAmt += Number((element.orderQuantityKgs * element.sale_Price).toFixed(2));
          this.totBasePremiumFlavourPrice += Number((element.basePremiumFlavourPrice * element.orderQuantityKgs).toFixed(2));
          this.totPremiumFlavourPrice += Number((element.premiumFlavourPrice * element.orderQuantityKgs).toFixed(2));
          if (element.discountAmt) {
            this.totDiscount += Number((element?.discountAmt * element.orderQuantityKgs).toFixed(2));
          }
          if (element.taxAmount) {
            this.gstAmt += Number((element?.taxAmount).toFixed(2));
          }
          if (element.cessAmount) {
            this.cessAmt += Number((element?.cessAmount).toFixed(2));
          }
          this.totTaxValue = (this.totalSaleAmt + this.totBasePremiumFlavourPrice) - this.totDiscount;
          this.totalNetAmt = this.totTaxValue + this.gstAmt + this.cessAmt;
        }

        this.deliveryCharge = 0;
        this.distanceDeliveryCharge = 0;
        this.slotDiscDeliveryCharge = 0;
        this.slotPremiumDeliveryCharge = 0;
        this.valueDeliveryCharge = 0;
        this.deliverySetup.forEach((c) => {
          if (Number(this.totalNetAmt.toFixed(0)) >= c.fromValue && Number(this.totalNetAmt.toFixed(0)) <= c.toValue) {
            this.deliveryCharge = Number((c.deliveryCharge).toFixed(2)) + Number((this.webOrderDeliverySetupDto?.deliveryChargeByDistance).toFixed(2));
            this.distanceDeliveryCharge = Number((this.webOrderDeliverySetupDto?.deliveryChargeByDistance).toFixed(2));
            this.valueDeliveryCharge = Number((c.deliveryCharge).toFixed(2));
          }
        });
        let matchedSlot = false;
        this.webOrderDeliveryTimeSlotSetup.forEach(w => {
          console.log(w)
          // if (this.deliveryType === 'storePickup') {
          //   // For storePickup, do not apply any discounts or premiums, just allow the offer
          //   this.allowOffer = "1";
          // } 
          // else if (this.deliveryType === 'delivery' && element.deliveryTime == w.timeSlot) {
          //   // Apply discounts/premiums only in delivery mode when timeSlot matches
          //   this.slotDiscDeliveryCharge = Number(((this.deliveryCharge * w.deliveryDiscount) / 100).toFixed(0));
          //   this.slotPremiumDeliveryCharge = Number(((this.deliveryCharge * w.deliveryPremium) / 100).toFixed(0));
          //   this.deliveryCharge = this.deliveryCharge + this.slotPremiumDeliveryCharge - this.slotDiscDeliveryCharge;
          //   this.allowOffer = w.allowOffer;
          //   matchedSlot = true;
          // }
          if (element.deliveryTime == w.timeSlot) {
            console.log("sunil")
            // Apply discounts/premiums only in delivery mode when timeSlot matches
            this.slotDiscDeliveryCharge = Number(((this.deliveryCharge * w.deliveryDiscount) / 100).toFixed(0));
            this.slotPremiumDeliveryCharge = Number(((this.deliveryCharge * w.deliveryPremium) / 100).toFixed(0));
            this.deliveryCharge = this.deliveryCharge + this.slotPremiumDeliveryCharge - this.slotDiscDeliveryCharge;
            this.allowOffer = w.allowOffer;
            matchedSlot = true;
          }
        });
        // If no slot is selected or matched, default to allow offer
        if (!matchedSlot) {
          this.allowOffer = "1";
        }

        this.roundedOffAmount = Math.round(this.totalNetAmt) - this.totalNetAmt;
        this.netAmountBeforeRoundedOff = this.totalNetAmt;
        this.totalNetAmt = Math.round(this.totalNetAmt);
        this.grandTotal = this.totalNetAmt + this.deliveryCharge;
      });

      return {
        dateTime,
        games: groups[dateTime],
        totalSaleAmt: this.totalSaleAmt,
        totBasePremiumFlavourPrice: this.totBasePremiumFlavourPrice,
        totPremiumFlavourPrice: this.totPremiumFlavourPrice,
        totDiscount: this.totDiscount,
        totTaxValue: this.totTaxValue,
        gstAmt: this.gstAmt,
        cessAmt: this.cessAmt,
        totalNetAmt: this.totalNetAmt,
        roundedOffAmount: this.roundedOffAmount,
        netAmountBeforeRoundedOff: this.netAmountBeforeRoundedOff,
        deliveryCharge: this.deliveryCharge,
        valueDeliveryCharge: this.valueDeliveryCharge,
        slotDiscDeliveryCharge: this.slotDiscDeliveryCharge,
        slotPremiumDeliveryCharge: this.slotPremiumDeliveryCharge,
        distanceDeliveryCharge: this.distanceDeliveryCharge,
        deliveryAddressRefNo: this.productOrderSummary.deliveryAddressRefNo,
        allowOffer: this.allowOffer,
        grandTotal: this.grandTotal,
      };
    });
    this.groupProduct = groupArrays;

    this.isAllAllowed = true;
    // this.isShowCheckOut = true;
    this.groupProduct.forEach(element => {
      if (element.dateTime && element.games?.[0]?.deliveryTime) {
        element.dateTime = element.dateTime.substring(0, 10) + " " + element.games[0].deliveryTime;
      } else {
        element.dateTime = null;
      }
      this.allCartTotal += element.grandTotal;
      if (element.totalNetAmt < this.minimumOrdeSetup.orderMinValue) {
        this.isAllAllowed = false;
      }
      // this.processClick(element);
    });
    this.processClick(this.groupProduct);
    this.sanitizeProductImage();

    return this.groupProduct.sort((a, b) => {
      return <any>new Date(a.date) - <any>new Date(b.date);
    });
  }

  processClick(cartList: any) {
    this.isShowCheckOut = false;
    let offerCartList: any[] = [];
    this.allCartTotal = 0;
    const locId: number = JSON.parse(this.localStorage.getItem("location_code"));
    cartList.forEach(cart => {
      console.log(cart)
      if (cart.allowOffer && cart.allowOffer == '1') {
        cart.discount = cart.totDiscount;
        cart.totalPaid = 0;
        cart.details = cart.games.filter(e => e.cartProductType == 'Product');
        cart.subTotal = 0;
        cart.fromLocationCode = locId;
        cart.details.forEach(element => {
          element.productCode = element.product_Code;
          element.productName = element.product_Name;
          element.netAmt = element.net_Sale_Price * element.orderQuantity;
          element.qty = element.orderQuantity;
          element.discAmt = element.discountAmt;
          element.discPercent = element.discountRate;
          element.total = element.sale_Price * element.orderQuantity;
          element.sgstRate = (element.tax?.taxRate ?? 0.0) / 2;
          element.cgstRate = (element.tax?.taxRate ?? 0.0) / 2;
          element.igstRate = 0.0;
          element.ugstRate = 0.0;
          element.cessRate = (element.cess?.cessRate ?? 0.0) / 2;
          cart.subTotal = cart.subTotal + element.total;
        });
        offerCartList.push(cart);
        this.allCartTotal += cart.grandTotal;
      } else {
        this.totalNetAmt = 0;
        this.totalSaleAmt = 0;
        this.totDiscount = 0;
        this.totTaxValue = 0;
        this.gstAmt = 0;
        this.cessAmt = 0;
        this.totBasePremiumFlavourPrice = 0;
        this.totPremiumFlavourPrice = 0;
        this.roundedOffAmount = 0;
        this.netAmountBeforeRoundedOff = 0;

        cart.games.forEach(element => {
          let appliedOffer: ViewOfferSetUpDto = element.offerDetails?.find(temp => temp.offerId == element.offerId);
          if (appliedOffer) {
            if (appliedOffer.schemeType == "Buy 1 get 1 Free" || appliedOffer.schemeType == "Buy X get Y Free") {
              let offerIndex = cart.games.findIndex(e => e.freeByProductCode === element.product_Code);
              if (offerIndex >= 0)
                cart.games.splice(offerIndex, 1);
            }
          }

          element.offers = null;
          element.discountAmt = 0;
          element.discountRate = 0;
          element.discPercent = 0.0;
          element.discAmt = 0.0;
          element.promotionOfferId = null;
          element.offerId = null;

          var taxableAmt = element.sale_Price + element.basePremiumFlavourPrice;
          var cgst = (element.tax.taxRate / 2 / 100) * taxableAmt;
          element.cgstAmt = cgst;
          var sgst = (element.tax.taxRate / 2 / 100) * taxableAmt;
          element.sgstAmt = sgst;
          element.taxAmount = cgst + sgst;
          element.cessAmount = (element.cess.cessRate / 100) * taxableAmt;


          if (element.orderQuantityKgs == null) {
            this.totalSaleAmt += Number((element.orderQuantity * element.sale_Price).toFixed(2));
            if (element.discountAmt) {
              this.totDiscount += Number((element?.discountAmt * element.orderQuantity).toFixed(2));
            }
            if (element.taxAmount) {
              this.gstAmt += Number((element.orderQuantity * element?.taxAmount).toFixed(2));
            }
            if (element.cessAmount) {
              this.cessAmt += Number((element.orderQuantity * element?.cessAmount).toFixed(2));
            }
            this.totTaxValue = (this.totalSaleAmt + this.totBasePremiumFlavourPrice) - this.totDiscount;
            this.totalNetAmt = this.totTaxValue + this.gstAmt + this.cessAmt;
          } else {
            this.totalSaleAmt += Number((element.orderQuantityKgs * element.sale_Price).toFixed(2));
            this.totBasePremiumFlavourPrice += Number((element.basePremiumFlavourPrice * element.orderQuantityKgs).toFixed(2));
            this.totPremiumFlavourPrice += Number((element.premiumFlavourPrice * element.orderQuantityKgs).toFixed(2));
            if (element.discountAmt) {
              this.totDiscount += Number((element?.discountAmt * element.orderQuantityKgs).toFixed(2));
            }
            if (element.taxAmount) {
              this.gstAmt += Number((element.orderQuantityKgs * element?.taxAmount).toFixed(2));
            }
            if (element.cessAmount) {
              this.cessAmt += Number((element.orderQuantityKgs * element?.cessAmount).toFixed(2));
            }
            this.totTaxValue = (this.totalSaleAmt + this.totBasePremiumFlavourPrice) - this.totDiscount;
            this.totalNetAmt = this.totTaxValue + this.gstAmt + this.cessAmt;
          }

          this.deliveryCharge = 0;
          this.deliverySetup.forEach((c) => {
            if (Number(this.totalNetAmt.toFixed(0)) >= c.fromValue && Number(this.totalNetAmt.toFixed(0)) <= c.toValue) {
              this.deliveryCharge = Number((c.deliveryCharge).toFixed(2)) + Number((this.webOrderDeliverySetupDto?.deliveryChargeByDistance).toFixed(2));
            }
          });
          let matchedSlot = false;
          this.webOrderDeliveryTimeSlotSetup.forEach(w => {
            if (this.deliveryType === 'storePickup') {
              this.allowOffer = "1";
            } else if (this.deliveryType === 'delivery' && element.deliveryTime == w.timeSlot) {
              this.deliveryCharge = this.deliveryCharge + Number(((this.deliveryCharge * w.deliveryPremium) / 100).toFixed(0)) - Number(((this.deliveryCharge * w.deliveryDiscount) / 100).toFixed(0));
              this.allowOffer = w.allowOffer;
              matchedSlot = true;
            }
          });
          // If no slot is selected or matched, default to allow offer
          if (!matchedSlot) {
            this.allowOffer = "1";
          }
          this.roundedOffAmount = Math.round(this.totalNetAmt) - this.totalNetAmt;
          this.netAmountBeforeRoundedOff = this.totalNetAmt;
          this.totalNetAmt = Math.round(this.totalNetAmt);
          this.grandTotal = this.totalNetAmt + this.deliveryCharge;
        });

        cart.totalSaleAmt = this.totalSaleAmt;
        cart.totBasePremiumFlavourPrice = this.totBasePremiumFlavourPrice;
        cart.totPremiumFlavourPrice = this.totPremiumFlavourPrice;
        cart.totDiscount = this.totDiscount;
        cart.totTaxValue = this.totTaxValue;
        cart.gstAmt = this.gstAmt;
        cart.cessAmt = this.cessAmt;
        cart.totalNetAmt = this.totalNetAmt;
        cart.roundedOffAmount = this.roundedOffAmount;
        cart.netAmountBeforeRoundedOff = this.netAmountBeforeRoundedOff;
        cart.deliveryCharge = this.deliveryCharge;
        cart.allowOffer = this.allowOffer;
        cart.grandTotal = this.grandTotal;
        this.allCartTotal += cart.grandTotal;

      }
    });
    if (offerCartList.length > 0) {
      this.processSubscription = this.cartService.cashRegProcess(this.apiFactory.summaryOfferOperation, offerCartList).subscribe((dataList: any) => {
        this.isShowCheckOut = true;
        dataList.forEach((data, index) => {
          if (data) {
            let cart = cartList.filter(e => e.allowOffer == '1')[index];
            if (data.discount) {
              let totTaxAmt = 0;
              let totCessAmt = 0;
              cart.details?.forEach(element => {
                if (data.details.some(temp => temp.productCode == element.productCode)) {
                  let discProduct = data.details.find(e => e.productCode == element.productCode);
                  element.offerDiscAmt = discProduct.offerDiscAmt;
                  element.offerDiscRate = discProduct.offerDiscRate;
                  element.cgstRate = discProduct.cgstRate;
                  element.sgstRate = discProduct.sgstRate;
                  element.taxableValue = discProduct.taxableValue;
                }
                element.cessAmt = (element.cessRate / 100) * element.taxableValue;
                element.cgstAmt = (element.cgstRate / 100) * element.taxableValue;
                element.sgstAmt = (element.sgstRate / 100) * element.taxableValue;
                element.taxAmount = element.cgstAmt + element.sgstAmt;
                totTaxAmt += Number((element?.taxAmount).toFixed(2));
                totCessAmt += Number((element?.cessAmount).toFixed(2));
              });

              cart.offerId = data.offerId;
              cart.discountApplied = ' (' + 'Applied: ' + data.cartOffers[0]?.schemeName + ')';
              cart.offerDiscAmt = Number((data?.discount).toFixed(2));
              cart.offerDiscRate = data?.offerDiscRate;
              cart.totDiscount = Number((cart.discount + cart.offerDiscAmt).toFixed(2));
              cart.totTaxValue = (cart.totalSaleAmt + cart.totBasePremiumFlavourPrice) - cart.totDiscount;
              cart.gstAmt = totTaxAmt;
              cart.cessAmt = totCessAmt;
              cart.totalNetAmt = cart.totTaxValue + cart.gstAmt + cart.cessAmt;

              cart.deliveryCharge = 0;
              this.deliverySetup.forEach((c) => {
                if (cart.totalNetAmt >= c.fromValue && cart.totalNetAmt <= c.toValue) {
                  cart.deliveryCharge = Number((c.deliveryCharge).toFixed(2)) + Number((this.webOrderDeliverySetupDto?.deliveryChargeByDistance).toFixed(2));
                }
              });
              let matchedSlot = false;
              this.webOrderDeliveryTimeSlotSetup.forEach(w => {
                if (cart.dateTime?.split(' ')[1] == w.timeSlot) {
                  cart.deliveryCharge = cart.deliveryCharge + Number(((cart.deliveryCharge * w.deliveryPremium) / 100).toFixed(0)) - Number(((cart.deliveryCharge * w.deliveryDiscount) / 100).toFixed(0));
                  cart.allowOffer = w.allowOffer;
                  matchedSlot = true;
                }
              });
              // If no slot is selected or matched, default to allow offer
              if (!matchedSlot) {
                this.allowOffer = "1";
              }

              // cart.deliveryCharge = 0;
              // this.deliverySetup.forEach((c) => {
              //   if (cart.totalNetAmt >= c.fromValue && cart.totalNetAmt <= c.toValue) {
              //     cart.deliveryCharge = Number((c.deliveryCharge).toFixed(2)) + Number((c.deliveryChargeByDistance).toFixed(2));
              //   }
              // });
              cart.roundedOffAmount = Math.round(cart.totalNetAmt) - cart.totalNetAmt;
              cart.netAmountBeforeRoundedOff = cart.totalNetAmt;
              cart.totalNetAmt = Math.round(cart.totalNetAmt);
              this.allCartTotal = this.allCartTotal - cart.grandTotal;
              cart.grandTotal = cart.totalNetAmt + cart.deliveryCharge;
              this.allCartTotal = cart.grandTotal + this.allCartTotal;
            } else if (data.details.length > cart.details?.length) {
              let freeItem = data.details.find(e => e.baseAmt == 0 && !e.productName.includes('Buy X get Y Free') && !e.productName.includes('Buy 1 get 1 Free'))
              freeItem.product_Code = freeItem.productCode;
              freeItem.product_Name = freeItem.productName + ' (' + data.cartOffers[0]?.schemeType + ')';
              freeItem.product_Unit = freeItem.productUnit;
              freeItem.sale_Price = freeItem.netAmt;
              freeItem.net_Sale_Price = freeItem.netAmt;
              freeItem.basePremiumFlavourPrice = 0;
              freeItem.premiumFlavourPrice = 0;
              freeItem.orderQuantity = 1;
              freeItem.qty = 1;
              freeItem.tax = freeItem.productdetail?.tax;
              freeItem.cess = freeItem.productdetail?.cess;
              freeItem.food_Type = freeItem.productdetail?.food_Type;
              freeItem.hsn_Code = freeItem.productdetail?.hsn_Code;
              freeItem.max_Discount_Percentage = freeItem.productdetail?.max_Discount_Percentage;
              freeItem.product_Type = freeItem.productdetail?.product_Type;
              let anyCartItem = cart.details.find(e => e.sale_Price > 0);
              freeItem.defaultDate = anyCartItem.defaultDate;
              freeItem.deliveryDate = anyCartItem.deliveryDate;
              freeItem.deliveryTime = anyCartItem.deliveryTime;
              freeItem.cartProductType = anyCartItem.cartProductType;

              cart.offerId = data.offerId;
              cart.details.push(freeItem);
              cart.games.push(freeItem);
            }
          }
        });
      },
        (error: HttpErrorResponse) => {
          this.isShowCheckOut = true;
        });
    } else
      this.isShowCheckOut = true;

  }

  sanitizeProductImage() {
    this.groupProduct.forEach(cart => {
      cart.games.forEach(product => {
        if (product.image && product.image.changingThisBreaksApplicationSecurity) {
          // Create a new sanitized property instead of replacing the original
          product.sanitizedImageUrl = this.sanitizer.bypassSecurityTrustUrl(
            product.image.changingThisBreaksApplicationSecurity
          );
        }
      });
    });
  }

  onPayClick(cart: any) {
    if (this.isAgreedTerms) {
      // Convert to array if it's a single object
      const cartItems = Array.isArray(cart) ? cart : [cart];

      for (let item of cartItems) {
        // Check if delivery date & slot is missing
        if (!item.dateTime || item.dateTime.trim() === '') {
          this.toastService.showErrorToast('Please select delivery date & slot.');
          return;
        }
      }
      // Call the checkDeliveryTime method
      const isDeliveryTimeInvalid = this.checkDeliveryTime(cart);

      if (isDeliveryTimeInvalid) {
        // If delivery time is in the past or current, show error toast
        this.toastService.showErrorToast('Delivery time is in the past. Please select a future delivery slot.');
        return;
      }
      // if (this.deliveryType == 'delivery') {
      let deliveryCheckDto: WebOrderDeliveryCheckDto = new WebOrderDeliveryCheckDto();
      if (cart.length == undefined) {
        deliveryCheckDto.deliveryDateTime.push(cart.dateTime);
        deliveryCheckDto.deliveryDates.push(cart.dateTime.split(' ')[0]);
        deliveryCheckDto.deliverySlots.push(cart.dateTime.split(' ')[1]);
        deliveryCheckDto.url = this.currentUrl;
        deliveryCheckDto.locId = JSON.parse(this.localStorage.getItem("location_code"));
      } else {
        cart.forEach((element1) => {
          deliveryCheckDto.deliveryDateTime.push(element1.dateTime);
          deliveryCheckDto.deliveryDates.push(element1.dateTime.split(' ')[0]);
          deliveryCheckDto.deliverySlots.push(element1.dateTime.split(' ')[1]);
          deliveryCheckDto.url = this.currentUrl;
          deliveryCheckDto.locId = JSON.parse(this.localStorage.getItem("location_code"));
        });
      }
      this.checkServicesAllowedOrNotSubcription = this.cartService.checkServiceAllowedOrNot(this.apiFactory.checkServicesAllowedOrNotByDeliveryTime, deliveryCheckDto)
        .subscribe((response: any) => {
          if (response.data && response.data == 'Success') {
            this.getDeliveryAddress(cart);
          } else {
            this.toastService.showErrorToast(response.data);
          }
        });
      // }
      // else if (this.deliveryType == 'storePickup') {
      //   this.getDeliveryAddress(cart);
      // } 
      // else {
      // }
    } else {
      this.isAnimate = true;
      this.toastService.showErrorToast("Please agreed to the terms and conditions");
      setTimeout(() => {
        this.isAnimate = false;
      }, 500);
    }
  }

  // Method to check if the cart's delivery time is in the past
  checkDeliveryTime(cart: any): boolean {
    // Check if cart is an array
    if (Array.isArray(cart)) {
      // Handle array case, iterate over each element (if needed)
      for (let element of cart) {
        const cartDateTime = element.dateTime; // Assuming dateTime is available in the element
        const cartDateTimeParts = cartDateTime.split(' '); // Split into [date, timeRange]
        const date = cartDateTimeParts[0]; // "2024-12-02"
        const timeRange = cartDateTimeParts[1]; // "19:00-21:00"
        const [startTime, endTime] = timeRange.split('-'); // Split into ["19:00", "21:00"]

        // Construct a full datetime string for the start time (e.g., "2024-12-02 19:00")
        const startDateTime = `${date} ${startTime}`;

        // Get current datetime
        const currentDateTime = moment(); // Moment will default to the current date and time
        const cartStartTime = moment(startDateTime, "YYYY-MM-DD HH:mm");

        // Compare the start time of the cart with the current time
        if (cartStartTime.isBefore(currentDateTime) || cartStartTime.isSame(currentDateTime)) {
          // If any of the cart start times are less than or equal to current time, return true
          return true;
        }
      }
    } else {
      // Handle object case (cart is a single object)
      const cartDateTime = cart.dateTime;
      const cartDateTimeParts = cartDateTime.split(' '); // Split into [date, timeRange]
      const date = cartDateTimeParts[0]; // "2024-12-02"
      const timeRange = cartDateTimeParts[1]; // "19:00-21:00"
      const [startTime, endTime] = timeRange.split('-'); // Split into ["19:00", "21:00"]

      // Construct a full datetime string for the start time (e.g., "2024-12-02 19:00")
      const startDateTime = `${date} ${startTime}`;

      // Get current datetime
      const currentDateTime = moment(); // Moment will default to the current date and time
      const cartStartTime = moment(startDateTime, "YYYY-MM-DD HH:mm");

      // Compare the start time of the cart with the current time
      if (cartStartTime.isBefore(currentDateTime) || cartStartTime.isSame(currentDateTime)) {
        // If the cart start time is less than or equal to current time, return true
        return true;
      }
    }

    // Return false if all delivery times are valid (future time)
    return false;
  }

  getDeliveryAddress(cart: any) {
    this.gstSaleInvcumBOS = new GstSaleInvCumBosDto();
    this.productOrderSummaryService.setWebOrder(this.gstSaleInvcumBOS);

    let gstSaleInvcumBOSArray: GstSaleInvCumBosDto[] = [];
    this.productOrderSummaryService.setWebOrderArray(gstSaleInvcumBOSArray);

    let currTime = moment(new Date()).format("HH:mm");

    if (cart.length == undefined) {
      this.gstSaleInvcumBOS.notes = "Bill From Order";
      this.gstSaleInvcumBOS.invoiceType = "B2C";
      this.gstSaleInvcumBOS.billType = "Web Order";
      this.gstSaleInvcumBOS.status = "Confirmed";
      this.gstSaleInvcumBOS.shippingCharge = cart.deliveryCharge;
      this.gstSaleInvcumBOS.offerId = cart.offerId;

      var arr = new Array();
      cart.games.forEach((element) => {
        if (!element.freeByProductCode) {
          let productCartDto: ProductCartDto = new ProductCartDto();
          productCartDto.promotionOfferId = element.promotionOfferId;
          productCartDto.offerId = element.offerId;
          productCartDto.productCode = element.product_Code;
          productCartDto.productName = element.product_Name;
          if (element.cartProductType == "Make To Order") {
            productCartDto.qty = element.orderQuantityKgs;
          } else {
            productCartDto.qty = element.orderQuantity;
          }
          productCartDto.basePremiumFlavourPrice = element.basePremiumFlavourPrice;
          productCartDto.premiumFlavourPrice = element.premiumFlavourPrice;
          productCartDto.price = element.sale_Price + element.basePremiumFlavourPrice;
          productCartDto.total = productCartDto.qty * productCartDto.price;
          if (element.discountRate === undefined || element.discountRate == null) {
            productCartDto.discPercent = 0.0;
            productCartDto.discAmt = 0.0;
          } else {
            productCartDto.discPercent = element.discountRate;
            productCartDto.discAmt = element.discountAmt * productCartDto.qty;
          }
          if (element.offerDiscRate) {
            productCartDto.offerDiscRate = element.offerDiscRate;
            productCartDto.offerDiscAmt = element.offerDiscAmt;
          }

          this.productOrderSummary.cartProducts.forEach((e) => {
            if (e.product_Code == element.product_Code) {
              productCartDto.deliveryDate = e.deliveryDate;
              productCartDto.deliveryTime = e.deliveryTime;
            }
          });

          productCartDto.baseAmt = productCartDto.total;
          productCartDto.netAmt = element.net_Sale_Price * productCartDto.qty + productCartDto.premiumFlavourPrice * productCartDto.qty;
          productCartDto.sgstRate = element.tax?.taxRate / 2;
          productCartDto.cgstRate = element.tax?.taxRate / 2;
          productCartDto.igstRate = 0.0;
          productCartDto.ugstRate = 0.0;
          productCartDto.cessRate = element.cess?.cessRate;

          productCartDto.taxRate = element.tax?.taxRate;
          productCartDto.discountRate = element.discountRate;
          productCartDto.cartProductType = element.cartProductType;
          productCartDto.color = element.color;
          productCartDto.shape = element.shape;
          productCartDto.composition = element.composition;
          productCartDto.dimension = element.dimension;
          productCartDto.note = element.note;
          productCartDto.productUnit = element.product_Unit;
          productCartDto.productType = element.product_Type;
          productCartDto.maxDiscountPercentage = element.max_Discount_Percentage;
          productCartDto.hsnCode = element.hsn_Code;
          productCartDto.subGroupCode = productCartDto.subGroupCode = element.productSubGroup ? element.productSubGroup.refNo : element.subGroupCode;
          productCartDto.fileNames = element.fileNames;
          productCartDto.productPicture = element.product_Picture;
          if (element.deliveryTime.substring(0, 5) <= currTime.substring(0, 5)) {
            let currTime = moment(new Date().setMinutes(1)).format("HH:mm");
            productCartDto.dateOfDelivery = moment(new Date(element.deliveryDate)).format("YYYY-MM-DD") + " " + currTime.substring(0, 5) + ":00";
          }
          else
            productCartDto.dateOfDelivery = moment(new Date(element.deliveryDate)).format("YYYY-MM-DD") + " " + element.deliveryTime.substring(0, 5) + ":00";

          arr.push(productCartDto);
        } else {
          let productCartDto: ProductCartDto = new ProductCartDto();
          if (element.cartProductType == "Make To Order") {
            productCartDto.promotionOfferId = element.promotionOfferId;
            productCartDto.offerId = element.offerId;
            productCartDto.freeByProductCode = element.freeByProductCode;
            productCartDto.productCode = element.product_Code;
            productCartDto.productName = element.product_Name;
            productCartDto.cartProductType = element.cartProductType;
            productCartDto.productUnit = element.product_Unit;
            productCartDto.productType = element.product_Type;
            productCartDto.hsnCode = element.hsn_Code;
            productCartDto.subGroupCode = element.subGroupCode;
            productCartDto.qty = element.orderQuantity;
            productCartDto.price = element.rate;
            productCartDto.total = productCartDto.qty * productCartDto.price;
            productCartDto.discPercent = 0.0;
            productCartDto.discAmt = 0.0;
            productCartDto.baseAmt = productCartDto.total;
            productCartDto.netAmt = element.net_Sale_Price;
            productCartDto.taxRate = 0.0;
            productCartDto.sgstRate = 0.0;
            productCartDto.cgstRate = 0.0;
            productCartDto.igstRate = 0.0;
            productCartDto.ugstRate = 0.0;
            productCartDto.cessRate = 0.0;
            productCartDto.fileNames = element.fileNames;
            productCartDto.productPicture = element.product_Picture;
            productCartDto.rate = element.rate;
            productCartDto.maxDiscountPercentage = element.max_Discount_Percentage;
            productCartDto.netAmountForLocation = element.netAmountForLocation;
            productCartDto.totalAmount = element.subTotal;
            this.productOrderSummary.cartProducts.forEach((e) => {
              if (e.product_Code == element.product_Code) {
                productCartDto.deliveryDate = e.deliveryDate;
                productCartDto.deliveryTime = e.deliveryTime;
              }
            });
            if (element.deliveryTime.substring(0, 5) <= currTime.substring(0, 5)) {
              let currTime = moment(new Date().setMinutes(1)).format("HH:mm");
              productCartDto.dateOfDelivery = moment(new Date(element.deliveryDate)).format("YYYY-MM-DD") + " " + currTime.substring(0, 5) + ":00";
            }
            else
              productCartDto.dateOfDelivery = moment(new Date(element.deliveryDate)).format("YYYY-MM-DD") + " " + element.deliveryTime.substring(0, 5) + ":00";

            arr.push(productCartDto);
          } else {
            productCartDto.promotionOfferId = element.promotionOfferId;
            productCartDto.offerId = element.offerId;
            productCartDto.freeByProductCode = element.freeByProductCode;
            productCartDto.productCode = element.product_Code;
            productCartDto.productName = element.product_Name;
            productCartDto.cartProductType = element.cartProductType;
            productCartDto.productUnit = element.product_Unit;
            productCartDto.productType = element.product_Type;
            productCartDto.hsnCode = element.hsn_Code;
            productCartDto.subGroupCode = productCartDto.subGroupCode = element.productSubGroup ? element.productSubGroup.refNo : element.subGroupCode;
            productCartDto.qty = element.orderQuantity;
            productCartDto.price = element.sale_Price;
            productCartDto.total = productCartDto.qty * productCartDto.price;
            productCartDto.discPercent = 0.0;
            productCartDto.discAmt = 0.0;
            productCartDto.baseAmt = productCartDto.total;
            productCartDto.netAmt = element.net_Sale_Price;
            productCartDto.taxRate = 0.0;
            productCartDto.sgstRate = 0.0;
            productCartDto.cgstRate = 0.0;
            productCartDto.igstRate = 0.0;
            productCartDto.ugstRate = 0.0;
            productCartDto.cessRate = 0.0;
            productCartDto.fileNames = element.fileNames;
            productCartDto.productPicture = element.product_Picture;
            this.productOrderSummary.cartProducts.forEach((e) => {
              if (e.product_Code == element.product_Code) {
                productCartDto.deliveryDate = e.deliveryDate;
                productCartDto.deliveryTime = e.deliveryTime;
              }
            });
            if (element.deliveryTime.substring(0, 5) <= currTime.substring(0, 5)) {
              let currTime = moment(new Date().setMinutes(1)).format("HH:mm");
              productCartDto.dateOfDelivery = moment(new Date(element.deliveryDate)).format("YYYY-MM-DD") + " " + currTime.substring(0, 5) + ":00";
            }
            else
              productCartDto.dateOfDelivery = moment(new Date(element.deliveryDate)).format("YYYY-MM-DD") + " " + element.deliveryTime.substring(0, 5) + ":00";

            arr.push(productCartDto);
          }
        }
      });
      this.gstSaleInvcumBOS.details = arr;
      this.gstSaleInvcumBOS.customerDeliveryAddress = this.productOrderSummaryService.getCustomerDeliveryAddress();
      this.gstSaleInvcumBOS.shippingTaxRate = this.webOrderDeliverySetupDto?.viewWebOrderGstSetupDto?.gstRate;
      this.gstSaleInvcumBOS.shippingCessRate = this.webOrderDeliverySetupDto?.viewWebOrderGstSetupDto?.cessRate;
      this.gstSaleInvcumBOS.shippingHsnCode = this.webOrderDeliverySetupDto?.viewWebOrderGstSetupDto?.hsnCode;
      this.gstSaleInvcumBOS.shippingType = this.webOrderDeliverySetupDto?.viewWebOrderGstSetupDto?.productType;
      this.gstSaleInvcumBOS.shippingUnit = this.webOrderDeliverySetupDto?.viewWebOrderGstSetupDto?.productUnit;
      this.gstSaleInvcumBOS.shippingMaxDiscountPercentage = this.webOrderDeliverySetupDto?.viewWebOrderGstSetupDto?.maxDiscountPercentage;
      this.gstSaleInvcumBOS.netAmountBeforeRoundedOff = cart.netAmountBeforeRoundedOff;
      this.gstSaleInvcumBOS.roundedOffAmount = cart.roundedOffAmount;
      this.googleDetails = JSON.parse(
        this.localStorage.getItem("google_loggedIn_details")
      );
      if (this.googleDetails != null) {
        let loginDeliveryAddress: LoginCustomerDetails = new LoginCustomerDetails();
        loginDeliveryAddress.firstName = this.googleDetails.firstName;
        loginDeliveryAddress.lastName = this.googleDetails.lastName;
        loginDeliveryAddress.name = this.googleDetails.name;
        loginDeliveryAddress.email = this.googleDetails.email;
        loginDeliveryAddress.phoneNo = this.googleDetails.phoneNo;
        if (this.gstSaleInvcumBOS.details.length != 0) {
          this.gstSaleInvcumBOS.loginDeliveryAddress = loginDeliveryAddress;
        }
      }
      this.productOrderSummaryService.setWebOrder(this.gstSaleInvcumBOS);
      this.productOrderSummary.shippingCharge = cart.deliveryCharge;
      this.productOrderSummary.totalPrice = cart.grandTotal;
      //Newly added
      this.amount = this.productOrderSummary.totalPrice.toFixed(2);
      this.availabeAmount = Number(this.amount);
    } else {
      cart.forEach((element1) => {
        var gstSale: GstSaleInvCumBosDto = new GstSaleInvCumBosDto();
        gstSale.notes = "Bill From Order";
        gstSale.invoiceType = "B2C";
        gstSale.billType = "Web Order";
        gstSale.status = "Confirmed";
        gstSale.shippingCharge = element1.deliveryCharge;
        gstSale.grandTotal = element1.grandTotal;
        gstSale.offerId = element1.offerId;

        var arr = new Array();
        element1.games.forEach((element) => {
          if (!element.freeByProductCode) {
            let productCartDto: ProductCartDto = new ProductCartDto();
            productCartDto.promotionOfferId = element.promotionOfferId;
            productCartDto.offerId = element.offerId;
            productCartDto.designForProductCode = element.designForProductCode;
            productCartDto.productCode = element.product_Code;
            productCartDto.productName = element.product_Name;
            if (element.cartProductType == "Make To Order") {
              productCartDto.qty = element.orderQuantityKgs;
            } else {
              productCartDto.qty = element.orderQuantity;
            }
            productCartDto.basePremiumFlavourPrice = element.basePremiumFlavourPrice;
            productCartDto.premiumFlavourPrice = element.premiumFlavourPrice;
            productCartDto.price = element.sale_Price + element.basePremiumFlavourPrice;
            productCartDto.total = productCartDto.qty * productCartDto.price;
            if (element.discountRate === undefined || element.discountRate == null) {
              productCartDto.discPercent = 0.0;
              productCartDto.discAmt = 0.0;
            } else {
              productCartDto.discPercent = element.discountRate;
              productCartDto.discAmt = element.discountAmt * productCartDto.qty;
            }
            if (element.offerDiscRate) {
              productCartDto.offerDiscRate = element.offerDiscRate;
              productCartDto.offerDiscAmt = element.offerDiscAmt;
            }

            this.productOrderSummary.cartProducts.forEach((e) => {
              if (e.product_Code == element.product_Code) {
                productCartDto.deliveryDate = e.deliveryDate;
                productCartDto.deliveryTime = e.deliveryTime;
              }
            });

            productCartDto.baseAmt = productCartDto.total;
            productCartDto.netAmt = element.net_Sale_Price * productCartDto.qty + productCartDto.premiumFlavourPrice * productCartDto.qty;
            productCartDto.sgstRate = element.tax?.taxRate / 2;
            productCartDto.cgstRate = element.tax?.taxRate / 2;
            productCartDto.igstRate = 0.0;
            productCartDto.ugstRate = 0.0;
            productCartDto.cessRate = element.cess?.cessRate;

            productCartDto.taxRate = element.tax?.taxRate;
            productCartDto.discountRate = element.discountRate;
            productCartDto.cartProductType = element.cartProductType;
            productCartDto.color = element.color;
            productCartDto.shape = element.shape;
            productCartDto.composition = element.composition;
            productCartDto.dimension = element.dimension;
            productCartDto.note = element.note;
            productCartDto.productUnit = element.product_Unit;
            productCartDto.productType = element.product_Type;
            productCartDto.maxDiscountPercentage = element.max_Discount_Percentage;
            productCartDto.hsnCode = element.hsn_Code;
            productCartDto.subGroupCode = productCartDto.subGroupCode = element.productSubGroup ? element.productSubGroup.refNo : element.subGroupCode;
            productCartDto.fileNames = element.fileNames;
            productCartDto.productPicture = element.product_Picture;
            if (element.deliveryTime.substring(0, 5) <= currTime.substring(0, 5)) {
              let currTime = moment(new Date().setMinutes(1)).format("HH:mm");
              productCartDto.dateOfDelivery = moment(new Date(element.deliveryDate)).format("YYYY-MM-DD") + " " + currTime.substring(0, 5) + ":00";
            }
            else
              productCartDto.dateOfDelivery = moment(new Date(element.deliveryDate)).format("YYYY-MM-DD") + " " + element.deliveryTime.substring(0, 5) + ":00";

            arr.push(productCartDto);
          } else {
            let productCartDto: ProductCartDto = new ProductCartDto();
            productCartDto.promotionOfferId = element.promotionOfferId;
            productCartDto.offerId = element.offerId;
            productCartDto.freeByProductCode = element.freeByProductCode;
            productCartDto.designForProductCode = element.designForProductCode;
            productCartDto.productCode = element.product_Code;
            productCartDto.productName = element.product_Name;
            productCartDto.cartProductType = element.cartProductType;
            productCartDto.productUnit = element.product_Unit;
            productCartDto.productType = element.product_Type;
            productCartDto.hsnCode = element.hsn_Code;
            productCartDto.subGroupCode = productCartDto.subGroupCode = element.productSubGroup ? element.productSubGroup.refNo : element.subGroupCode;
            productCartDto.qty = element.orderQuantity;
            productCartDto.price = element.sale_Price;
            productCartDto.total = productCartDto.qty * productCartDto.price;
            productCartDto.discPercent = 0.0;
            productCartDto.discAmt = 0.0;
            productCartDto.baseAmt = productCartDto.total;
            productCartDto.netAmt = element.net_Sale_Price;
            productCartDto.taxRate = 0.0;
            productCartDto.sgstRate = 0.0;
            productCartDto.cgstRate = 0.0;
            productCartDto.igstRate = 0.0;
            productCartDto.ugstRate = 0.0;
            productCartDto.cessRate = 0.0;
            productCartDto.fileNames = element.fileNames;
            productCartDto.productPicture = element.product_Picture;
            this.productOrderSummary.cartProducts.forEach((e) => {
              if (e.product_Code == element.product_Code) {
                productCartDto.deliveryDate = e.deliveryDate;
                productCartDto.deliveryTime = e.deliveryTime;
              }
            });
            if (element.deliveryTime.substring(0, 5) <= currTime.substring(0, 5)) {
              let currTime = moment(new Date().setMinutes(1)).format("HH:mm");
              productCartDto.dateOfDelivery = moment(new Date(element.deliveryDate)).format("YYYY-MM-DD") + " " + currTime.substring(0, 5) + ":00";
            }
            else
              productCartDto.dateOfDelivery = moment(new Date(element.deliveryDate)).format("YYYY-MM-DD") + " " + element.deliveryTime.substring(0, 5) + ":00";

            arr.push(productCartDto);
          }
        });
        gstSale.details = arr;
        gstSale.customerDeliveryAddress = this.productOrderSummaryService.getCustomerDeliveryAddress();
        gstSale.shippingTaxRate = this.webOrderDeliverySetupDto?.viewWebOrderGstSetupDto?.gstRate;
        gstSale.shippingCessRate = this.webOrderDeliverySetupDto?.viewWebOrderGstSetupDto?.cessRate;
        gstSale.shippingHsnCode = this.webOrderDeliverySetupDto?.viewWebOrderGstSetupDto?.hsnCode;
        gstSale.shippingType = this.webOrderDeliverySetupDto?.viewWebOrderGstSetupDto?.productType;
        gstSale.shippingUnit = this.webOrderDeliverySetupDto?.viewWebOrderGstSetupDto?.productUnit;
        gstSale.shippingMaxDiscountPercentage = this.webOrderDeliverySetupDto?.viewWebOrderGstSetupDto?.maxDiscountPercentage;
        gstSale.netAmountBeforeRoundedOff = element1.netAmountBeforeRoundedOff;
        gstSale.roundedOffAmount = element1.roundedOffAmount;
        gstSaleInvcumBOSArray.push(gstSale);
      });
      this.googleDetails = JSON.parse(
        this.localStorage.getItem("google_loggedIn_details")
      );
      if (this.googleDetails != null) {
        let loginDeliveryAddress: LoginCustomerDetails = new LoginCustomerDetails();
        loginDeliveryAddress.firstName = this.googleDetails.firstName;
        loginDeliveryAddress.lastName = this.googleDetails.lastName;
        loginDeliveryAddress.name = this.googleDetails.name;
        loginDeliveryAddress.email = this.googleDetails.email;
        loginDeliveryAddress.phoneNo = this.googleDetails.phoneNo;
        if (gstSaleInvcumBOSArray.length != 0) {
          gstSaleInvcumBOSArray.forEach((e) => {
            e.loginDeliveryAddress = loginDeliveryAddress;
          });
        }
      }
      this.productOrderSummaryService.setWebOrderArray(gstSaleInvcumBOSArray);
      this.productOrderSummary.shippingCharge = this.deliveryCharge;
      this.productOrderSummary.totalPrice = this.allCartTotal;
      //Newly added
      this.amount = this.productOrderSummary.totalPrice.toFixed(2);
      this.availabeAmount = Number(this.amount);
    }
    // this.dialog.closeAll();
    // this.navRoute.navigate(["/process-payment"]);
    this.payWithCCavenue();
    // this.dialog.open(GstinDialogComponent, {
    //   width: "350px",
    //   autoFocus: false,
    // });

    // this.googleId = JSON.parse(this.localStorage.getItem("google_id"));
    // this.fbId = JSON.parse(this.localStorage.getItem("fb_id"));

    // if (this.googleId != null || this.fbId != null) {
    //   this.navRoute.navigate(["/delivery-address"]);
    // } else {
    //   this.navRoute.navigate(["/login", "checkout"]);
    // }


  }

  openPrivacyPolicyDialog() {
    // const dialogRef = this.dialog.open(PrivacyPolicyComponent, {
    //   width: "700px",
    //   height: "750px",
    //   data: "generalTerms",
    //   autoFocus: false,
    //   panelClass: ["animate__animated", "animate__slideInUp"],
    // });

    // dialogRef.afterClosed().subscribe((result) => { });
  }

  getDeliveryChargeTooltip(cart: any): string {
    let tooltip = '';

    if (cart.valueDeliveryCharge > 0) {
      tooltip += `Delivery Charge for Value: ${cart.valueDeliveryCharge}\n`;
    }
    if (cart.distanceDeliveryCharge > 0) {
      tooltip += `Delivery Charge for Distance: ${cart.distanceDeliveryCharge}\n`;
    }
    if (cart.slotDiscDeliveryCharge > 0) {
      tooltip += `Discount on Delivery Charge: ${cart.slotDiscDeliveryCharge}\n`;
    }
    if (cart.slotPremiumDeliveryCharge > 0) {
      tooltip += `Premium on Delivery Charge: ${cart.slotPremiumDeliveryCharge}`;
    }

    return tooltip.trim(); // Remove any trailing newline characters
  }

  openDeliveryTimeDialog(product: Product) {
    const dialogRef = this.dialog.open(DeliveryTimeDialogComponent, {
      width: '430px',
      height: '410px',
      maxWidth: '90vw',
      autoFocus: false,
      restoreFocus: false,
      data: { product: JSON.parse(JSON.stringify(product)), deliveryTimeSlotSetup: this.webOrderDeliveryTimeSlotSetup },
      panelClass: 'custom-dialog-container',
      disableClose: true
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.parseDate(result.data.deliveryDate, result.data.product_Code);
        this.onTimeChange(result.data.deliveryTime, result.data.product_Code);
      }
    });
  }

  convertToAmPm(timeRange: string): string {
    if (timeRange.includes('-')) {
      const times = timeRange.split('-');
      const startTime = this.formatTime(times[0]);
      const endTime = this.formatTime(times[1]);
      return `${startTime} - ${endTime}`;
    } else {
      return timeRange;
    }
  }

  formatTime(time: string): string {
    const [hour, minute] = time.split(':');
    const date = new Date();
    date.setHours(+hour);
    date.setMinutes(+minute);
    return new Intl.DateTimeFormat('en-US', {
      hour: 'numeric',
      minute: 'numeric',
      hour12: true
    }).format(date);
  }

  messageInput(key: string, product: Product) {
    product.note = this.mesageForm.get('note').value;
  }

  parseDate(dateString: string, code: number) {
    // this.selectedDate = dateString;
    this.productOrderSummary.cartProducts.forEach((element) => {
      if (element.product_Code == code) {
        element.deliveryDate = dateString;
        element.selectedDate = dateString;
      }
      else if (element.freeByProductCode == code) {
        element.deliveryDate = dateString;
        element.selectedDate = dateString;
      }
      else if (element.designForProductCode == code) {
        element.deliveryDate = dateString;
        element.selectedDate = dateString;
      }

    });
    // this.sortProductByDate(true);
  }

  onTimeChange(timeSlot: string, code: number) {
    this.productOrderSummary.cartProducts.forEach((element) => {
      if (element.product_Code == code) {
        element.deliveryTime = timeSlot;
      }
      else if (element.freeByProductCode == code) {
        element.deliveryTime = timeSlot;
      }
      else if (element.designForProductCode == code) {
        element.deliveryTime = timeSlot;
      }
    });
    this.sortProductByDate(true);
  }

  // Check if all groups are eligible for checkout
  areAllGroupsEligibleForCheckout(): boolean {
    if (!this.groupProduct || this.groupProduct.length === 0) return false;

    const minOrderValue = this.minimumOrdeSetup?.orderMinValue || 0;

    // Check if ALL groups meet minimum order requirement
    return this.groupProduct.every(cart =>
      (cart?.totalNetAmt || 0) >= minOrderValue
    );
  }

  // Pay all groups together
  payAllGroups(): void {
    if (!this.areAllGroupsEligibleForCheckout() || !this.isAgreedTerms) {
      return;
    }

    // Implement your logic to pay all groups
    // This could call onPayClick for each group or a separate bulk payment method
    console.log('Paying all groups:', this.groupProduct);

    // If you want to pay groups sequentially:
    this.groupProduct.forEach(cart => {
      this.onPayClick(cart);
    });
  }

  // For individual group payment, use existing onPayClick method


  // Newly added
  orderId: string;
  amount: string;
  availabeAmount: number = 0;
  cCAvenueurl: string;
  parentLocationCode: number;
  deliveryAddress: CustomerDeliveryAddress = new CustomerDeliveryAddress();
  customerDTO: CustomerDTO = new CustomerDTO();
  usedWallet: number = 0;
  webUrl: string;

  private getGatewaySetupSubscription: Subscription;
  private sendRequestGatewaySubscription: Subscription;
  private onWebOrderInsertSubscription: Subscription;

  payWithCCavenue() {
    try {
      this.onPayClickLog();
    } catch (error) {
      console.error("Error in PayClick:", error);
    }
    // this.checkStockAndProceed(() => {
    let locationCode: number = JSON.parse(this.localStorage.getItem("location_code"));
    this.orderId = this.getRandomString();
    // this.getCCAvenueData();

    this.getGatewaySetupSubscription = this.cartService.getGatewaySetup(this.apiFactory.getGatewayPaymentSetup, locationCode, "CCAvenue", this.webUrl).subscribe((data: GatewayPaymentSetup) => {
      if (data) {
        this.getCCAvenueData(data);
      }
    });

    // this.getTempdata();
    // this.getTransactionDetailsCCAvenue();

    // this.form.nativeElement.submit();
    // console.log(this.productOrderSummaryService.getWebOrder());
    // this.navRoute.navigate(["/payment-status"]);
    // });
  }

  onPayClickLog(): void {
    this.cartService.logPayClick(this.apiFactory.paymentLogPayClick);
  }

  getRandomString() {
    var myDate = moment(new Date()).format("YYYYMMDDHHmmssSSS");
    var moduleName = "CAPORD";
    var locId = JSON.parse(this.localStorage.getItem("location_code"));
    let fornattedLoc = locId < 10 ? '000' + '' + locId : locId < 100 ? '00' + '' + locId : locId < 1000 ? '0' + '' + locId : locId;
    var randomstring = moduleName + fornattedLoc + myDate;
    console.log(randomstring)
    return randomstring;
    // var myDate = new Date();
    // var result = myDate.getTime();
    // var characters = "ABCDEFGHIJKLMNOPQRSTUVWZYZ";
    // var lenString = 6;
    // var randomstring = "";
    // for (var i = 0; i < lenString; i++) {
    //   var rnum = Math.floor(Math.random() * characters.length);
    //   randomstring += characters.substring(rnum, rnum + 1);
    // }
    // return "WEB"+randomstring + result;
  }

  logVisit() {
    const webUserInfo = JSON.parse(this.localStorage.getItem("web_user_info") || '{}');

    const payload = {
      userName: this.googleCustomer?.name || '',
      email: this.googleCustomer?.email || '',
      mobileNumber: this.googleCustomer?.phoneNo || '',
      location: {
        city: webUserInfo.city || '',
        state: webUserInfo.state || '',
        country: webUserInfo.country || '',
        latitude: webUserInfo.latitude || null,
        longitude: webUserInfo.longitude || null
      }
    };
    this.cartService.logVisit(this.apiFactory.paymentLogVisit, payload);
  }

  gstSaleInvcumBOSArray: GstSaleInvCumBosDto[] = [];
  getCCAvenueData(data: GatewayPaymentSetup) {
    this.gstSaleInvcumBOSArray = this.productOrderSummaryService.getWebOrderArray();

    let ccAvenue: CCAvenueDataFormat = new CCAvenueDataFormat();
    console.log(this.availabeAmount)
    ccAvenue.amount = this.availabeAmount;
    ccAvenue.orderId = this.orderId;
    ccAvenue.merchantId = data.merchantId;
    ccAvenue.source = "capitalfood.in";
    var fiveMinutesLater = new Date();
    console.log(fiveMinutesLater)
    fiveMinutesLater.setMinutes(fiveMinutesLater.getMinutes() + 5);
    console.log(fiveMinutesLater)

    ccAvenue.validTill = moment(fiveMinutesLater).format("yyyy-MM-DDTHH:mm:ss");

    let addressData: CustomerDeliveryAddress;
    let loginEmail: string;
    console.log(this.gstSaleInvcumBOS)
    if (this.gstSaleInvcumBOS.details.length != 0) {
      addressData = this.gstSaleInvcumBOS.customerDeliveryAddress;
      loginEmail = this.gstSaleInvcumBOS.loginDeliveryAddress.email;
    } else if (this.gstSaleInvcumBOSArray.length != 0) {
      addressData = this.gstSaleInvcumBOSArray[0].customerDeliveryAddress;
      loginEmail = this.gstSaleInvcumBOSArray[0].loginDeliveryAddress.email;
    }

    if (addressData) {
      ccAvenue.name = addressData.contactName;
      ccAvenue.billing_name = addressData.contactName;
      ccAvenue.billing_address = addressData.shippingAddress;
      ccAvenue.billing_city = addressData.cityName;
      ccAvenue.billing_state = addressData.stateName;
      ccAvenue.billing_zip = addressData.shippingPinCode.toString();
      ccAvenue.billing_country = "India";
      ccAvenue.billing_tel = addressData.contactMobile.toString();
      ccAvenue.billing_email = loginEmail;
    }
    console.log(JSON.stringify(ccAvenue))
    this.sendRequestGatewaySubscription = this.cartService.checkPaytmStatus(this.apiFactory.sendGatewayPaymentRequest, JSON.stringify(ccAvenue), this.webUrl).subscribe((encdata: any) => {
      if (encdata) {
        // console.log(encdata);
        // this.cCAvenueurl = this.appConfig.setting.paymentUrl + "ccavenue?data=" + encdata.encResp + "&access=" + data.accessCode
        //   + "&orderid=" + ccAvenue.orderId + "&sourceLogo=https://1bakeshop.com/assets/img/logo.webp";
        // console.log(this.cCAvenueurl);
        this.router.navigate(['/payment'], {
          queryParams: {
            data: encdata.encResp,
            access: data.accessCode,
            orderid: ccAvenue.orderId,
            tenantId: this.appConfig.setting.tenantId,
            sourceLogo: 'https://capitalfood.in/assets/img/logo.webp'
          }
        });
        this.getTransactionDetailsCCAvenue();
      }
      else {
        this.toastService.showErrorToast('Server side error');
      }
    });
    // this.orderId = this.getRandomString();
    // this.productMinMaxPriceSubscription = this.commonService.getCCAvenueCred(this.apiUrl.ccAvenuePayment, this.orderId, this.availabeAmount.toString())
    //   .subscribe((data: any) => {
    //     this.encRequest = data;
    //     this.getTransactionDetailsCCAvenue();
    //   });
  }

  getTransactionDetailsCCAvenue() {
    let locationCode: number = JSON.parse(this.localStorage.getItem("location_code"));
    let stateCode: number = JSON.parse(this.localStorage.getItem("state_code"));
    let orderFromTvLocation: number = JSON.parse(this.localStorage.getItem("orderFromTvLocation"));

    if (this.gstSaleInvcumBOS.details.length != 0) {
      let momentDate = new Date(this.gstSaleInvcumBOS.details[0].deliveryDate);
      let formattedDate = moment(new Date(momentDate)).format("YYYY-MM-DD");
      this.gstSaleInvcumBOS.locationCode = locationCode;
      this.gstSaleInvcumBOS.invoicingLocationCode = this.parentLocationCode;
      this.gstSaleInvcumBOS.deliveryDate = formattedDate;
      this.gstSaleInvcumBOS.deliveryTime = this.gstSaleInvcumBOS.details[0].deliveryTime;
      this.gstSaleInvcumBOS.orderFromTvLocation = orderFromTvLocation;
      this.gstSaleInvcumBOS.url = this.currentUrl;
      this.gstSaleInvcumBOS.customerCode = this.googleCustomer.refNo;
      this.gstSaleInvcumBOS.deliveryAddressRefNo = this.productOrderSummary.deliveryAddressRefNo;

      this.productOrderSummaryService.setWebOrder(this.gstSaleInvcumBOS);

      this.deliveryAddress = this.gstSaleInvcumBOS.customerDeliveryAddress;

      this.customerDTO.customerName = this.gstSaleInvcumBOS.loginDeliveryAddress.name;
      this.customerDTO.customerMobile = this.gstSaleInvcumBOS.loginDeliveryAddress.phoneNo;
      this.customerDTO.customerEmail = this.gstSaleInvcumBOS.loginDeliveryAddress.email;
      this.customerDTO.stateCode = stateCode;
      this.customerDTO.fromLocationCode = locationCode;
      this.customerDTO.location.refNo = locationCode;
      this.customerDTO.location.stateCode = stateCode;
      this.gstSaleInvcumBOS.customer = this.customerDTO;

      this.gstSaleInvcumBOS.walletPayment.amount = this.usedWallet;
      this.gstSaleInvcumBOS.walletPayment.fromLocationCode = locationCode;

      this.gstSaleInvcumBOS.totalAmt = Number(this.amount);

      // this.gstSaleInvcumBOS.gatewayPayment.amount = data["amount"];
      // this.gstSaleInvcumBOS.gatewayPayment.fromLocationCode = locationCode;
      // this.gstSaleInvcumBOS.gatewayPayment.paymentType = "CCAvenue";
      // this.gstSaleInvcumBOS.gatewayPayment.gatewayPaymentResponseCode = data["ref_no"];

      this.onWebOrderInsertSubscription = this.cartService.insertWebOrderTemp(this.apiFactory.insertWebOrderTemp, this.orderId, [this.gstSaleInvcumBOS])
        .subscribe((response: any) => {
          // window.location.href = this.cCAvenueurl;

        });

    }

    if (this.gstSaleInvcumBOSArray.length != 0) {
      this.gstSaleInvcumBOSArray.forEach((element) => {
        let momentDate = new Date(element.details[0].deliveryDate);
        let formattedDate = moment(new Date(momentDate)).format("YYYY-MM-DD");
        element.deliveryDate = formattedDate;
        element.deliveryTime = element.details[0].deliveryTime;
        element.locationCode = locationCode;
        element.invoicingLocationCode = this.parentLocationCode;
        element.orderFromTvLocation = orderFromTvLocation;
        element.url = this.currentUrl;
        element.customerCode = this.googleCustomer.refNo;
        element.deliveryAddressRefNo = this.productOrderSummary.deliveryAddressRefNo;

        element.walletPayment.amount = this.usedWallet;
        element.walletPayment.fromLocationCode = locationCode;

        element.totalAmt = Number(this.amount);

        // element.gatewayPayment.amount = data["amount"];
        // element.gatewayPayment.fromLocationCode = locationCode;
        // element.gatewayPayment.paymentType = "CCAvenue";
        // element.gatewayPayment.gatewayPaymentResponseCode = data["ref_no"];
      });
      this.deliveryAddress = this.gstSaleInvcumBOSArray[0].customerDeliveryAddress;

      this.customerDTO.customerName = this.gstSaleInvcumBOSArray[0].loginDeliveryAddress.name;
      this.customerDTO.customerMobile = this.gstSaleInvcumBOSArray[0].loginDeliveryAddress.phoneNo;
      this.customerDTO.customerEmail = this.gstSaleInvcumBOSArray[0].loginDeliveryAddress.email;
      this.customerDTO.stateCode = stateCode;
      this.customerDTO.fromLocationCode = locationCode;
      this.customerDTO.location.refNo = locationCode;
      this.customerDTO.location.stateCode = stateCode;

      this.gstSaleInvcumBOSArray[0].customer = this.customerDTO;

      this.onWebOrderInsertSubscription = this.cartService.insertWebOrderTemp(this.apiFactory.insertWebOrderTemp, this.orderId, this.gstSaleInvcumBOSArray)
        .subscribe((response: any) => {
          //this.sendUpiRequest(this.orderId);
          // window.location.href = this.cCAvenueurl;
        });
    }
  }
}